export const versionName = ''
export const myapiHost = 'https://api.tiantianyouhuo.com.cn/v1.0/agent'
